import { ConversationsContainer } from '@/modules/Conversations';

export const Conversations = (): JSX.Element => <ConversationsContainer />;

export default Conversations;
